// extracted by mini-css-extract-plugin
module.exports = {"footer_Button":"FooterButton_footer_Button__5xnyj","arrow_upward":"FooterButton_arrow_upward__IOgcc","footer__list":"FooterButton_footer__list__u8Qfp"};